import { c as _c } from "react/compiler-runtime";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { useEffect, useState } from "react";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function formatEnrolledCounts(enrolledCount: number, capacity_min: number, capacity_max: number | null, short = false) {
  function nHelden(count: number) {
    if (short) {
      return `${count}`;
    }
    return `${count} Held${count !== 1 ? "en" : ""}`;
  }
  if (capacity_max === null) {
    if (capacity_min === 0) {
      return nHelden(enrolledCount);
    } else {
      return `${enrolledCount} von mindestens ${nHelden(capacity_min)}`;
    }
  } else if (capacity_max === 0) {
    return `${nHelden(enrolledCount)} aber keine Helden erlaubt`;
  } else if (capacity_min === capacity_max) {
    if (enrolledCount === 0) {
      return `${nHelden(capacity_min)} gesucht`;
    } else {
      return `${enrolledCount} von ${nHelden(capacity_min)}`;
    }
  } else {
    if (enrolledCount === 0) {
      return `${capacity_min}-${nHelden(capacity_max)} gesucht`;
    }
    return `${enrolledCount} von ${capacity_min}-${nHelden(capacity_max)}`;
  }
}
export function useMediaQuery(query) {
  const $ = _c(3);
  const [matches, setMatches] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = () => {
      const media = window.matchMedia(query);
      setTimeout(() => setMatches(media.matches), 1);
      const listener = event => {
        setMatches(event.matches);
      };
      media.addEventListener("change", listener);
      return () => media.removeEventListener("change", listener);
    };
    t1 = [query];
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return matches;
}
function _temp() {
  return false;
}